module.exports = __webpack_public_path__ + "img/t6.40836551.png";